import { render } from "./ModuleMenuV2.vue?vue&type=template&id=4f17f22a&scoped=true"
import script from "./ModuleMenuV2.vue?vue&type=script&lang=js"
export * from "./ModuleMenuV2.vue?vue&type=script&lang=js"

import "./ModuleMenuV2.vue?vue&type=style&index=0&id=4f17f22a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f17f22a"]])

export default __exports__